
import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import { OfferSingle } from "@/services/offers/OfferSingle";
import { eventBus } from "@/eventbus";
import ImageInput from "@/components/base/form/ImageInput.vue";
import BaseCard from "@/components/base/BaseCard.vue";
import BaseButtonV2 from "@/components-UI/buttons/BaseButtonV2.vue";
import SvgDownload from "@/assets/icons/download.svg";
import { addOfferLogo, addOfferLogoV2, addOfferRoundLogo } from "@/api/offers";
import { downloadImageFromUrl, downloadFileToDisk } from "@/api";
import { showServerError } from "@/utils";
import BaseQuestionMarkTooltip from "@/components-UI/BaseQuestionMarkTooltip.vue";
import { useOfferDetailStore } from "@/store_v3/offerCard";
import { canEditOffers } from "@/utils/checkRole";

interface IHeaderOffer {
    id: number;
    name: string;
    value: any;
    newValue: string | File;
    api: Function;
    update: Function;
    isRound: boolean;
    tooltip?: string;
    tooltipWidth?: string
}

@Component({
    components: {
        QuestionMarkTooltip: BaseQuestionMarkTooltip,
        BaseCard,
        ImageInput,
        BaseButtonV2,
        SvgDownload,
    },
})
export default class OfferCardLogo extends Vue {
    get canEditOffer(): boolean {
        return canEditOffers();
    }

    @Prop({ required: true }) offer!: OfferSingle;
    @PropSync('isLoading') isLoadingSync!: boolean;

    isEdit = false;
    logo: any = null;
    logoToprec: any = null;
    logoRound: any = null;
    validFlags = {};
    store = useOfferDetailStore();

    get getOptions(): IHeaderOffer[] {
        return [
            {
                id: 0,
                name: 'Основной',
                value: this.offer.logo,
                newValue: this.logo,
                api: addOfferLogoV2,
                isRound: false,
                update: (file) => this.logo = file,
                tooltip: 'Отображается в ЛК партнёра.',
                tooltipWidth: 'max-content',
            },
            {
                id: 1,
                name: 'Для маркировки',
                value: this.offer.logo_toprec,
                newValue: this.logoToprec,
                api: addOfferLogo,
                isRound: false,
                update: (file) => this.logoToprec = file,
                tooltip: 'На основании этого логотипа создаётся креатив по умолчанию. При изменении этого логотипа, оффер  автоматически будет перемаркирован и для него будет создан новый erid.',
                tooltipWidth: this.$vuetify.breakpoint.width < 600 ? '200' : '320',
            },
            {
                id: 2,
                name: 'Круглый',
                value: this.offer.logo_round,
                newValue: this.logoRound,
                api: addOfferRoundLogo,
                isRound: true,
                update: (file) => this.logoRound = file,
                tooltip: 'Отображается в CRM. Также предназначен для виджетов.',
                tooltipWidth: '200',
            },
        ];
    }


    get isDisabled(): boolean {
        return this.isEdit ? this.offer.isDisabledOtherCards || Object.values(this.validFlags).some(i => i === false) : false;
    }

    editInfo(edit: boolean): void {
        if (!edit) {
            this.updateAllOfferData();
        }
        this.isEdit = edit;
    }

    cancelEdit(): void {
        eventBus.$emit('clear-image-input');
        this.isEdit = false;
    }

    updateLogo(file: any, item: IHeaderOffer): void {
        item.newValue = file;
        item.update(file);
    }

    downloadLogo(item: IHeaderOffer): void {
        if (item.newValue) {
            const name = item.newValue instanceof File ? item.newValue.name : `logo-${item.id}.${item.isRound ? 'svg' : 'png'}`;
            downloadFileToDisk(item.newValue, name);
        } else if (item.value && typeof item.value === 'string') {
            downloadImageFromUrl(item.value);
        }
    }

    async updateAllOfferData(): Promise<void> {
        this.isLoadingSync = true;
        try {
            for (const item of this.getOptions) {
                if (item.newValue) {
                    await item.api(item.newValue, this.offer.legacy_id!);
                }
            }
            if (this.getOptions.some(i => i.newValue !== null)) this.store.setIsUpdateOffer(true);
            eventBus.$emit('clear-image-input');
            this.$emit('update-offer');
        } catch (err) {
            showServerError(err, 'Ошибка загрузки логотипа');
        } finally {
            this.isLoadingSync = false;
        }
    }
}
